import messages from './exchange-rate-form-lang.json';
import VueFocus from 'vue-focus';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import eventBus from '../../../common/js/event-bus/event-bus';
import date from '../../../common/js/validators/date';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import datePicker from '../../../common/components/date-picker/date-picker';
import VueSelect from '../../../common/components/vue-select/vue-select.vue';
import { VueSelectOption } from '@ui-common/vue-select';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueDatepicker from '@ui-common/vue-datepicker';

const FOREIGN_INDIVIDUAL_DEADLINE = moment('2018.01.25', 'YYYY.MM.DD');

export default {
	data() {
		return {
			version: null,
			date: null,
			foreignType: null,
			focusedTab: null,
			foreignStandardDate: null
		};
	},
	i18n: { messages },
	validations() {
		return {
			date: {
				required,
				date: date(BACKEND_DATE_FORMAT)
			}
		};
	},
	mixins: [VueFocus.mixin],
	props: {
		versionInfo: {
			required: true
		},
		type: {
			type: String,
			required: true,
			validator: function (value) {
				return value == 'exchange' || value == 'MNB' || value == 'foreign';
			}
		},
		exchangeRateAfirUrl: {
			type: String
		},
		exchangeRateCardUrl: {
			type: String
		},
		exchangeRateConversionUrl: {
			type: String
		},
		editedLinks: {
			type: Boolean
		}
	},
	components: {
		'date-picker': datePicker,
		VueSelect,
		VueSelectOption,
		VueErrorMessage,
		VueDatepicker
	},
	computed: {
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		isMNB() {
			return this.type == 'MNB';
		},
		isForeign() {
			return this.type == 'foreign';
		},
		// O hatarozza meg a backend melyik api-t hivja majd
		backendType() {
			let type;
			if (this.type == 'foreign') {
				if (this.foreignType == 'standard') {
					type = 'foreignStandard';
				} else {
					type = 'foreignIndividual';
				}
			} else {
				type = this.type;
			}
			return type;
		},
		disabledSelect() {
			return this.versionInfo.versions.length <= 1;
		}
	},
	watch: {
		version() {
			this.changeVersion();
		},
		versionInfo(val) {
			if (val && val.versions && val.versions.length) {
				this.version = val.versions[0].version;
				if (this.isForeign && this.foreignType == 'standard') {
					this.foreignStandardDate = val.date;
				}
				this.date = val.date;
				this.changeVersion();
			}
		},
		foreignType(val) {
			if (val == 'standard' && moment(this.date, BACKEND_DATE_FORMAT).isSameOrBefore(FOREIGN_INDIVIDUAL_DEADLINE)) {
				this.date = this.foreignStandardDate;
			}
			this.getRates();
			this.$emit('on-type-change', val);
		}
	},
	methods: {
		uuid() {
			return window.crypto.randomUUID();
		},
		changeVersion() {
			let filteredVersions = this.versionInfo.versions.filter((version) => {
				return version.version == this.version;
			});
			if (filteredVersions.length) {
				this.$emit('on-version-change', filteredVersions[0]);
			}
		},
		getRates() {
			this.$v.$touch();
			if (this.date && !this.$v.date.$invalid) {
				this.$emit('on-date-change', this.backendType, this.date);
			}
		},
		getTimeLabel(version) {
			let timeLabel;
			if (this.$i18n.locale == 'hu') {
				timeLabel = version.time + ' (' + version.version + ')';
			} else {
				timeLabel = moment(version.time, 'HH:mm').format('hh:mm A') + ' (' + version.version + ')';
			}
			return timeLabel;
		},
		changeTab(tabId) {
			this.foreignType = tabId == '0' ? 'standard' : 'individual';
			this.focusedTab = tabId;
		},
		setForeignType(type) {
			this.foreignType = type;
		},
		closePopup() {
			this.$refs.download.focus();
		}
	},
	created() {
		this.date = moment().format(BACKEND_DATE_FORMAT);
		this.foreignType = 'standard';
		eventBus.$on('focusDownload', () => {
			this.closePopup();
		});
	}
};
